import { Button, DialogActions, DialogTitle, Tab, Tabs } from "@mui/material";
import GTextField from "../textfield/GTextField";
import { useMemo, useRef, useState } from "react";
import { useSnackbar } from "../dialog/SnackbarProvider";
import JWTApi from "./JWTApi";
import _ from "lodash";
import Validators from "../form/Validators";
import FormGroup from "../form/FormGroup";
import FormControl from "../form/FormControl";

export interface ILoginDialogProps {
    api:JWTApi
    children?:React.ReactElement|React.ReactElement[]
}

export default function LoginDialog(props:ILoginDialogProps){
    const {api} = props
    const email = useRef<any>()
    const name = useRef<any>()
    const password = useRef<any>()
    const confirm = useRef<any>()
    const [tab,setTab] = useState<string>("login")
    const {setSnackbar} = useSnackbar()
    const [busy,setBusy] = useState<boolean>(false)

    const onLogin = async () => {
        if (!form.dirty) form.markAllAsDirty()

        if (!email.current || !password.current || !form.valid || busy) return
        else setBusy(true)

        try {
            if (tab=="login") await api.login(email.current.value, password.current.value)
            else await api.register(email.current.value, password.current.value, name.current.value)
        }catch(e){
            setBusy(false)
            setSnackbar(e)
        }
    }

    const validateConfirm = (confirm:string) => password.current.value!=confirm ? "password must match" : ""

    const form = useMemo(() => {
        const controls = [
            new FormControl("email", [Validators.Required, Validators.Email]),
            new FormControl("password", [Validators.Required])
        ]
        if (tab=="signup") controls.push(new FormControl("name", [Validators.Required]), new FormControl("confirm", [validateConfirm]))
        return new FormGroup("login", controls)
    }, [tab])

    return <>
        <DialogTitle>
            <Tabs value={tab} onChange={(e,id:string) => setTab(id)}>
                <Tab label="Login" value="login"/>
                <Tab label="Signup" value="signup"/>
            </Tabs>
        </DialogTitle>
        <div className="content" key={tab}>
            {tab=="signup" && <GTextField id="textName" placeholder="Name" inputRef={name} floatLabel="Name" form={form} controlName="name" name="givenName"  autoComplete="given-name"/>}
            <GTextField id="textEmail" placeholder="E-mail" inputRef={email} floatLabel="E-mail" type="email" name="email" form={form} controlName="email" autoComplete="email"/>
            <GTextField id="textPass" placeholder="Password" inputRef={password} type="password" inputProps={{autoComplete:"hidden","aria-autocomplete":"none"}} onEnter={onLogin} floatLabel="Password" form={form} controlName="password"/>
            {tab=="signup" && <GTextField placeholder="confirm" inputRef={confirm} type="password" inputProps={{autoComplete:"hidden","aria-autocomplete":"none"}} floatLabel="Confirm" form={form} controlName="confirm"/>}
            {props.children}
        </div>
        <DialogActions>
            <Button variant="contained" onClick={onLogin} disabled={busy}>{tab=="login" ? "Login" : "Create"}</Button>
        </DialogActions>
    </>
}
